<template>
    <div v-if="loaded">
        <div class="border border-gray-dark">
            <h2 class="font-bold text-xl px-8 py-6">Activity Log</h2>
            <table class="w-full table-fixed" v-if="deliveries.length > 0">
                <thead>
                    <tr class="border border-gray-light bg-gray-light">
                        <th
                            class="hidden md:table-cell w-1/4 uppercase text-xs text-left px-8 py-3"
                        >
                            Date
                        </th>
                        <th
                            class="w-2/4 pl-2 md:pl-0 uppercase text-xs text-left py-3"
                        >
                            Slot
                        </th>
                        <th
                            class="w-1/4 pr-2 md:px-8 uppercase text-xs text-right py-3"
                        >
                            Emails Processed
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        class="border border-b border-gray-light"
                        v-for="(delivery, index) in deliveries"
                        :key="index"
                    >
                        <td class="hidden md:table-cell px-8 py-2">
                            {{ delivery.date }}
                        </td>
                        <td class="pl-2 md:pl-0 py-2 flex items-center">
                            <trend
                                class="w-16 mr-4 hidden md:inline"
                                :data="delivery.trend"
                                :gradient="['#7048e8']"
                                stroke-width="8"
                                smooth
                            >
                            </trend>
                            <span
                                >{{ delivery.slot }}
                                <span
                                    class="text-gray-darker"
                                    v-if="delivery.duration !== ''"
                                    >({{ delivery.duration }})</span
                                ></span
                            >
                        </td>
                        <td class="pr-2 md:px-8 py-2 text-right">
                            {{ delivery.count }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="text-center">
                <img
                    src="/images/empty-state.svg"
                    alt="No Activities Found"
                    class="mx-auto"
                />
                <p class="mx-8 md:md-16 xl:mx-64 my-16 font-bold text-primary">
                    🎉 Hold tight! As soon as Mailman starts processing incoming
                    emails, you'll see some stats here.
                </p>
            </div>
        </div>
        <nav class="mt-6" v-if="pagination.total && pagination.total > 1">
            <pagination-component
                :total="pagination.total"
                @change="onPage"
            ></pagination-component>
        </nav>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
export default {
    data() {
        return {
            deliveries: [],
            pagination: {},
            loaded: false,
            loading: false,
            loadingState: "...",
        };
    },
    mounted() {
        this.onPage(1);
    },
    methods: {
        onPage(page) {
            this.loading = true;

            axios
                .get(`/api/deliveries?page=${page}`)
                .then((response) => {
                    this.deliveries = response.data.data;
                    this.pagination = {
                        current: response.data.meta.current_page,
                        total: response.data.meta.last_page,
                    };
                    this.loaded = true;
                })
                .catch((err) => {
                    console.error(err);
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style></style>
